import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DropdownMenu = ({ items, onItemClick, activeSubsection = 0, setActiveSubsection }) => {
  const [localActiveSubsection, setLocalActiveSubsection] = useState(activeSubsection);
  const navigate = useNavigate();
  const qrCodeImage="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/qrcode.png";

  // Sync with external activeSubsection if provided
  useEffect(() => {
    if (typeof activeSubsection === 'number') {
      setLocalActiveSubsection(activeSubsection);
    }
  }, [activeSubsection]);

  // Check if this is the Knowledge section
  // const isKnowledgeSection = sectionName === 'Knowledge';

  // // If this is the Knowledge section, use the specialized component
  // if (isKnowledgeSection) {
  //   return <KnowledgeDropdown items={items} onItemClick={onItemClick} />;
  // }

  const handleSubsectionClick = (index, e) => {
    e.stopPropagation();
    setLocalActiveSubsection(index);
    if (setActiveSubsection) {
      setActiveSubsection(index);
    }
  };

  const handleItemClick = (item, e) => {
    e.stopPropagation();
    if (item.externalLink) {
      window.location.href = item.externalLink;
    } else if (item.route) {
      navigate(item.route);
    }
    onItemClick && onItemClick(item);
  };

  // Check if ANY item has subItems - this will determine our layout
  const hasAnyNestedSubsections = items?.some(item => item.subItems && item.subItems.length > 0);
  
  // Check if the current active item has subItems
  const activeItem = items?.[localActiveSubsection];
  const activeItemHasSubItems = activeItem?.subItems && activeItem.subItems.length > 0;

  return (
    <div className="fixed top-[80px] left-0 right-0 bottom-0 bg-gradient-to-b from-[#FFFFFF] to-[#E8EEF6] z-50 shadow-lg overflow-y-auto">
      <div className="flex h-full max-w-[1400px] mx-auto p-8">
        {hasAnyNestedSubsections ? (
          <>
            {/* First column for toggle menu - only shown if any item has nested subsections */}
            <div className="w-1/3 border-r border-[#E6E6E6] pr-8 flex flex-col">
              <div className="flex flex-col space-y-2 mb-8">
                {items?.map((section, index) => (
                  <button
                    key={index}
                    onClick={(e) => handleSubsectionClick(index, e)}
                    className={`w-full text-left px-6 py-4 rounded-xl transition-all duration-300 ${
                      localActiveSubsection === index
                        ? 'bg-gradient-to-r from-[#113262] to-[#1C52A0] text-white shadow-md'
                        : 'hover:bg-[#E8EEF6] text-[#262626] hover:shadow-sm'
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <h3 className="font-semibold text-xl">{section.title}</h3>
                      <svg 
                        className={`w-5 h-5 transition-transform duration-300 ${
                          localActiveSubsection === index ? 'text-[#FAD49D] rotate-90' : 'text-[#8A8A8A]'
                        }`}
                        fill="none" 
                        viewBox="0 0 24 24" 
                        stroke="currentColor"
                      >
                        <path 
                          strokeLinecap="round" 
                          strokeLinejoin="round" 
                          strokeWidth={2} 
                          d="M9 5l7 7-7 7"
                        />
                      </svg>
                    </div>
                  </button>
                ))}
              </div>
              
              {/* QR Code Section - replacing the Help section */}
              {hasAnyNestedSubsections ? (
                <div className="mt-auto mb-8 p-6 rounded-xl bg-gradient-to-br from-[#E8EEF6] to-[#FFFFFF] border border-[#E6E6E6] min-h-[300px] flex flex-col justify-center items-center" onClick={e => e.stopPropagation()} onMouseEnter={e => e.stopPropagation()}>
                  <h4 className="text-[#113262] font-semibold text-lg mb-3">Download App</h4>
                  <p className="text-[#545454] text-sm text-center mb-4">
                    Invest smart and track portfolios on the go.
                  </p>
                  <img 
                    src={qrCodeImage} 
                    alt="Maxiom Wealth App QR Code" 
                    className="w-full max-w-[180px] h-auto"
                    loading="lazy"
                    decoding="async"
                    />
                </div>
              ) : (
                <div className="mt-8 p-6 rounded-xl bg-gradient-to-br from-[#E8EEF6] to-[#FFFFFF] border border-[#E6E6E6] min-h-[300px] flex flex-col justify-center items-center" onClick={e => e.stopPropagation()} onMouseEnter={e => e.stopPropagation()}>
                  <h4 className="text-[#113262] font-semibold text-lg mb-3">Download App</h4>
                  <p className="text-[#545454] text-sm text-center mb-4">
                    Invest smart and track portfolios on the go.
                  </p>
                  <img 
                    src={qrCodeImage} 
                    alt="Maxiom Wealth App QR Code" 
                    className="w-full max-w-[180px] h-auto"
                    loading="lazy"
                    decoding="async"
                    />
                </div>
              )}
            </div>
            
            {/* Right content area - when toggle menu is present */}
            <div className="w-2/3 pl-8 flex flex-col">
              <div className="subsection-content">
                {activeItemHasSubItems && (
                  <div className="grid grid-cols-2 gap-6 pb-8">
                    {activeItem.subItems.map((item, index) => (
                      <div 
                        key={index}
                        onClick={(e) => handleItemClick(item, e)}
                        className="subsection-item group relative p-6 rounded-xl bg-white border border-[#E6E6E6] hover:border-[#1C52A0] transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg cursor-pointer h-auto"
                      >
                        <div className="absolute inset-0 bg-gradient-to-br from-[#1C52A0] to-[#0A1E3A] opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
                        <div className="relative">
                          <div className="flex items-start gap-4 mb-4">
                            <div className="w-6 h-6 flex-shrink-0 text-[#1C52A0] group-hover:text-[#113262] transition-colors duration-300">
                              {item.icon}
                            </div>
                            <h4 className="text-lg font-semibold text-[#113262] group-hover:text-[#0C131C] transition-colors duration-300">
                              {item.title}
                            </h4>
                          </div>
                          {/* Modified description styling for better wrapping */}
                          <div className="text-[#545454] text-sm leading-relaxed group-hover:text-[#262626] transition-colors duration-300 text-left whitespace-normal overflow-visible">
                            {item.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
                
                {/* If active item doesn't have subitems, display it directly */}
                {!activeItemHasSubItems && activeItem && (
                  <div className="grid grid-cols-2 gap-6 pb-8">
                    <div 
                      onClick={(e) => handleItemClick(activeItem, e)}
                      className="subsection-item group relative p-6 rounded-xl bg-white border border-[#E6E6E6] hover:border-[#1C52A0] transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg cursor-pointer h-auto"
                    >
                      <div className="absolute inset-0 bg-gradient-to-br from-[#1C52A0] to-[#0A1E3A] opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
                      <div className="relative">
                        <div className="flex items-start gap-4 mb-4">
                          <div className="w-6 h-6 flex-shrink-0 text-[#1C52A0] group-hover:text-[#113262] transition-colors duration-300">
                            {activeItem.icon || (
                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                              </svg>
                            )}
                          </div>
                          <h4 className="text-lg font-semibold text-[#113262] group-hover:text-[#0C131C] transition-colors duration-300">
                            {activeItem.title}
                          </h4>
                        </div>
                        {/* Modified description styling for better wrapping */}
                        <div className="text-[#545454] text-sm leading-relaxed group-hover:text-[#262626] transition-colors duration-300 text-left whitespace-normal overflow-visible">
                          {activeItem.description || `View all ${activeItem.title} content`}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          // If NO items have nested subsections, still maintain the layout structure
          <>
            {/* First column reserved for consistency - even when no toggle menu */}
            <div className="w-1/3 border-r border-[#E6E6E6] pr-8 flex flex-col">
              {/* QR Code Image positioned at the top when no toggle menu */}
              <div className="mt-8 p-6 rounded-xl bg-gradient-to-br from-[#E8EEF6] to-[#FFFFFF] border border-[#E6E6E6] min-h-[300px] flex flex-col justify-center items-center" onClick={e => e.stopPropagation()} onMouseEnter={e => e.stopPropagation()}>
                <h4 className="text-[#113262] font-semibold text-lg mb-3">Download App</h4>
                <p className="text-[#545454] text-sm text-center mb-4">
                  Invest smart and track portfolios on the go.
                </p>
                <img 
                  src={qrCodeImage} 
                  alt="Maxiom Wealth App QR Code" 
                  className="w-full max-w-[180px] h-auto"
                  loading="lazy"
                  decoding="async"
                  />
              </div>
            </div>
            
            {/* Right panel for items - maintains the 2/3 width */}
            <div className="w-2/3 pl-8 flex flex-col">
              <div className="grid grid-cols-2 gap-6 pb-8">
                {items?.map((item, index) => (
                  <div 
                    key={index}
                    onClick={(e) => handleItemClick(item, e)}
                    className="subsection-item group relative p-6 rounded-xl bg-white border border-[#E6E6E6] hover:border-[#1C52A0] transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg cursor-pointer h-auto"
                  >
                    <div className="absolute inset-0 bg-gradient-to-br from-[#1C52A0] to-[#0A1E3A] opacity-0 group-hover:opacity-5 transition-opacity duration-300"></div>
                    <div className="relative">
                      <div className="flex items-start gap-4 mb-4">
                        <div className="w-6 h-6 flex-shrink-0 text-[#1C52A0] group-hover:text-[#113262] transition-colors duration-300">
                          {item.icon || (
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                            </svg>
                          )}
                        </div>
                        <h4 className="text-lg font-semibold text-[#113262] group-hover:text-[#0C131C] transition-colors duration-300">
                          {item.title}
                        </h4>
                      </div>
                      {/* Modified description styling for better wrapping */}
                      <div className="text-[#545454] text-sm leading-relaxed group-hover:text-[#262626] transition-colors duration-300 text-left whitespace-normal overflow-visible">
                        {item.description || `View all ${item.title} content`}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DropdownMenu;